import comp from '../components/barrel';
import svg from '../js/svg';

export default {
  application_uuid: null,
  testament: null,
  party1_name: null,
  party1_user_uuid: null,
  party1_soleheir_uuid: null,
  party1_soleheir_name: null,
  party2_name: null,
  party2_user_uuid: null,
  party2_soleheir_uuid: null,
  party2_soleheir_name: null,
  relationships: null,
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;
    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-app-summary', vars));
    this.recipe.methods.push(await O.mPOST('application/get-heir-details', vars));
    this.recipe.methods.push(await O.mPOST('communal/relationships', vars));
    //this.recipe.methods.push(await O.mPOST('communal/relationships', vars));
    // this.recipe.methods.push(await O.mPOST('application/get-sole-heir', vars));
    // this.recipe.methods.push(await O.mPOST('application/get-heir-list', vars));
    // this.recipe.methods.push(await O.mPOST('application/get-obliteration-list', vars));

    // Clear table to prevent duplication when sum ratios (Better solution needed)
    if (await U.id('heir_list')) {
      U.id('heir_list').innerHTML = '';
    }
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    Object.keys(communal).length === 0 && (await U.getCommunalDropdowns());
    this.relationships = data[`communal/relationships`].data;
    const summary = data['application/get-app-summary'].data;
    
    // Check if summary is an array or object
    if (Array.isArray(summary) && summary.length > 0) {
      this.testament = summary[0].testament;
    } else if (summary && summary.testament) {
      this.testament = summary.testament;
    } else {
      this.testament = 'Single'; // Default fallback
    }
    
    const summaryObj = Array.isArray(summary) && summary.length > 0 ? summary[0] : summary || {};
    this.appSummary = summaryObj;

    const heirs = data['application/get-heir-details'].data;
    this.heirsData = heirs;
    this.noteSubjectOptions = this.buildNoteSubjectOptions(heirs, summaryObj);

    // const heirs = data['application/get-sole-heir'].data;
    // const heirList = data['application/get-heir-list'].data;
    // const famOblitList = data['application/get-obliteration-list'].data;

    this.party1_name = heirs.party1.name;
    this.party1_user_uuid = heirs.party1.user_uuid;
    this.party1_soleheir_name = heirs.party1.heir_name;
    this.party1_soleheir_uuid = heirs.party1.heir_uuid;
    await this.setHeirNotes(heirs);

    //@steph here is the heir_notes // [{"table_index","application_uuid","note"}]

    // -------------------------------
    //Sole heir section
    if (this.testament === 'Joint') {
      this.party2_user_uuid = heirs.party2.user_uuid;
      this.party2_name = heirs.party2.name;
      this.party2_soleheir_name = heirs.party2.heir_name;
      this.party2_soleheir_uuid = heirs.party2.heir_uuid;

      await this.buildSoleHeirs(heirs);
      await this.renderSectionNotes({
        containerId: 'heirNotes_party1_Div',
        sectionIndex: 4,
        label: `Notes to Party 1 - ${heirs.party1.name}`,
      });
      await this.renderSectionNotes({
        containerId: 'heirNotes_party2_Div',
        sectionIndex: 1,
        label: `Notes to Party 2 - ${heirs.party2.name}`,
      });
    } else {
      U.hide('soleHeirDiv');
    }

    // -------------------------------
    // Allocate heirs section

    await this.buildHeirListTable(heirs.heir_list);
    this.checkRatio('noUpdt');
    this.testament === 'Joint' ? (U.id('hB').innerHTML = 'B. Will of the survivor and/or in the event of simultaneous death') : (U.id('hB').innerHTML = 'A. Heir Ratio');

    const heirListNotesLabel =
      this.testament === 'Joint'
        ? 'Notes for Will of the survivor and/or in the event of simultaneous death'
        : 'Notes for heir ratio (residue)';
    await this.renderSectionNotes({
      containerId: 'heirNotes_2_Div',
      sectionIndex: 2,
      label: heirListNotesLabel,
    });

    // -------------------------------
    // Family Obliteration section
    await this.buildFamOblitHeirListTable(heirs.obliteration_list);
    this.checkRatio('noUpdt');
    this.testament === 'Joint' ? (U.id('hC').innerHTML = 'C. Family Obliteration') : (U.id('hC').innerHTML = 'B. Family Obliteration');

    await this.renderSectionNotes({
      containerId: 'heirNotes_oblit_Div',
      sectionIndex: 3,
      label: 'Notes for Family Obliteration',
      singleNote: true,
      showSubject: false,
    });

    // Attach listeners after DOM is in final location (core copies shadowDiv to target div, which destroys nodes)
    setTimeout(() => this.attachAllNoteListeners(), 0);
  },
  notesForSection(sectionIndex) {
    const section = Number(sectionIndex);
    return (this.heirNotesList || [])
      .filter((note) => Number(note.table_index) % 10 === section)
      .sort((a, b) => Number(a.table_index) - Number(b.table_index));
  },
  nextTableIndex(sectionIndex) {
    const section = Number(sectionIndex);
    const existing = this.notesForSection(section);
    if (!existing.length) return section;
    return Math.max(...existing.map((note) => Number(note.table_index))) + 10;
  },
  async renderSectionNotes({ containerId, sectionIndex, label, singleNote = false, showSubject = true }) {
    const div = U.id(containerId);
    if (!div) return;
    div.innerHTML = '';
    const existing = this.notesForSection(sectionIndex);

    if (singleNote) {
      const note =
        existing.find((n) => Number(n.table_index) === Number(sectionIndex)) || existing[0];
      if (note) {
        await this.appendNoteCard(div, {
          idKey: note.table_index,
          tableIndex: note.table_index,
          value: note.note,
          label,
          party: note.party,
          party_uuid: note.party_uuid,
          mode: 'update',
          sectionIndex,
          showSubject: false,
        });
      } else {
        await this.appendNoteCard(div, {
          idKey: `new_${sectionIndex}`,
          tableIndex: sectionIndex,
          value: '',
          label,
          mode: 'add',
          sectionIndex,
          showSubject: false,
        });
      }
      return;
    }

    for (const note of existing) {
      await this.appendNoteCard(div, {
        idKey: note.table_index,
        tableIndex: note.table_index,
        value: note.note,
        label,
        party: note.party,
        party_uuid: note.party_uuid,
        mode: 'update',
        sectionIndex,
        showSubject,
      });
    }
    await this.appendNoteCard(div, {
      idKey: `new_${sectionIndex}`,
      tableIndex: `new_${sectionIndex}`,
      value: '',
      label,
      mode: 'add',
      sectionIndex,
      showSubject,
    });
  },
  async appendNoteCard(container, { idKey, tableIndex, value, label, party, party_uuid, mode, sectionIndex, showSubject = true }) {
    const card = U.divAtt('div', 'class', 'mb-6');
    card.id = `heirNoteCard_${idKey}`;

    if (showSubject) {
      const heading = U.divAtt('p', 'class', 'text-grey mb-2');
      heading.textContent = mode === 'add' ? 'Add new note' : 'Existing note';
      card.appendChild(heading);

      const initSubject =
        this.findNoteSubjectValue(party, party_uuid) ||
        (mode === 'add' ? this.defaultNoteSubjectValue(sectionIndex) : '');
      const subjectSelect = await comp.select_v2({
        elID: `heirNotesSubject_${idKey}`,
        ddData: this.noteSubjectOptions || [],
        valueDataName: 'option_value',
        textDataName: 'option_label',
        labelName: 'Party or heir',
        requiredYN: 1,
        initValue: initSubject,
      });
      card.appendChild(subjectSelect);
    }

    const text = await comp.textarea(`heirNotes_${idKey}`, value || '', label, 0);
    card.appendChild(text);

    const actions = U.divAtt('div', 'class', 'flex items-center gap-3 mb-2');
    const primaryBtn = U.divAtt('button', 'class', 'btn');
    primaryBtn.id = `updateNotesBtn_${idKey}`;
    primaryBtn.disabled = true;
    if (mode === 'add') {
      primaryBtn.textContent = showSubject ? 'Add new notes' : 'Add notes';
      primaryBtn.setAttribute('onclick', `thsSubTab.addNewNote(${sectionIndex})`);
      actions.appendChild(primaryBtn);
    } else {
      primaryBtn.textContent = 'Update notes';
      primaryBtn.setAttribute('onclick', `thsSubTab.updateExistingNote(${tableIndex})`);
      actions.appendChild(primaryBtn);
      const removeBtn = U.divAtt('button', 'class', 'btn-outline');
      removeBtn.id = `removeNotesBtn_${idKey}`;
      removeBtn.textContent = 'Remove notes';
      removeBtn.setAttribute('onclick', `thsSubTab.removeNotes(${tableIndex})`);
      actions.appendChild(removeBtn);
    }
    card.appendChild(actions);
    container.appendChild(card);
  },
  attachNoteCardListener(cardId, updateBtnId) {
    const card = U.id(cardId);
    const btn = U.id(updateBtnId);
    if (!card || !btn) return;
    const enable = () => {
      btn.disabled = false;
    };
    const textarea = card.querySelector('textarea');
    if (textarea && String(textarea.value || '').trim()) {
      enable();
    }
    card.addEventListener('focusin', (e) => {
      if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') enable();
    });
    card.addEventListener('input', (e) => {
      if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') enable();
    });
    card.addEventListener('change', (e) => {
      if (e.target.tagName === 'SELECT') enable();
    });
  },
  attachAllNoteListeners() {
    (this.heirNotesList || []).forEach((note) => {
      this.attachNoteCardListener(`heirNoteCard_${note.table_index}`, `updateNotesBtn_${note.table_index}`);
    });
    [1, 2, 3, 4].forEach((section) => {
      this.attachNoteCardListener(`heirNoteCard_new_${section}`, `updateNotesBtn_new_${section}`);
    });
  },
  async refreshHeirDetails() {
    const vars = { application_uuid: this.application_uuid };
    const data = await O.PREP([
      await O.mPOST('application/get-app-summary', vars),
      await O.mPOST('application/get-heir-details', vars),
      await O.mPOST('communal/relationships', vars),
    ]);
    await this.loadPage(data);
  },
  async setHeirNotes(heirs) {
    this.heirNotesList = heirs.heir_notes || [];
    this.heir_notes_1 = '';
    this.heir_notes_2 = '';
    this.heir_notes_3 = '';
    this.heir_notes_4 = '';
    this.heir_notes_meta = {};
    this.heirNotesList.forEach((notes) => {
      this[`heir_notes_${notes.table_index}`] = notes.note;
      this.heir_notes_meta[notes.table_index] = {
        party: notes.party || '',
        party_uuid: notes.party_uuid || '',
      };
    });
  },
  personDisplayName(person) {
    if (!person) return '';
    return (
      person.name ||
      person.full_name ||
      [person.f_name, person.s_name].filter(Boolean).join(' ') ||
      ''
    );
  },
  buildNoteSubjectOptions(heirs, summary) {
    const options = [];
    const seen = new Set();
    const add = (party, party_uuid, option_label) => {
      if (!party_uuid || !option_label) return;
      const option_value = `${party}|${party_uuid}`;
      if (seen.has(option_value)) return;
      seen.add(option_value);
      options.push({ option_value, option_label, party, party_uuid });
    };

    const addParty = (key, index) => {
      const fromHeirs = heirs?.[key] || {};
      const uuid = fromHeirs.user_uuid || summary?.[`party${index}_user_uuid`];
      const name = this.personDisplayName(fromHeirs) || summary?.[`party${index}_full_name`];
      if (!uuid || !name) return;
      add(key, uuid, `${name} (Party ${index})`);
    };

    addParty('party1', 1);
    addParty('party2', 2);
    addParty('party3', 3);
    addParty('party4', 4);

    const addHeirGroup = (list) => {
      if (!list) return;
      (list.children || []).forEach((row) => {
        add('heir', row.heir_uuid, `${this.personDisplayName(row)} (Child)`);
      });
      (list.heirs || []).forEach((row) => {
        add('heir', row.heir_uuid, `${this.personDisplayName(row)} (Heir)`);
      });
      (list.company || []).forEach((row) => {
        add('heir', row.heir_uuid, `${this.personDisplayName(row)} (Organisation)`);
      });
    };

    addHeirGroup(heirs?.heir_list);
    return options;
  },
  findNoteSubjectValue(party, party_uuid) {
    const options = this.noteSubjectOptions || [];
    if (party && party_uuid) {
      const exact = options.find((opt) => opt.party === party && opt.party_uuid === party_uuid);
      if (exact) return exact.option_value;
    }
    if (party_uuid) {
      const byUuid = options.find((opt) => opt.party_uuid === party_uuid);
      if (byUuid) return byUuid.option_value;
    }
    const normalised = String(party || '')
      .toLowerCase()
      .replace(/\s/g, '');
    if (normalised === 'party1' || normalised === 'party2' || normalised === 'party3' || normalised === 'party4' || normalised === 'heir') {
      const byParty = options.find((opt) => opt.party === normalised);
      if (byParty) return byParty.option_value;
    }
    return '';
  },
  defaultNoteSubjectValue(tableIndex) {
    const options = this.noteSubjectOptions || [];
    if (tableIndex === 1) {
      return options.find((opt) => opt.party === 'party2')?.option_value || '';
    }
    if (tableIndex === 4) {
      return options.find((opt) => opt.party === 'party1')?.option_value || '';
    }
    return '';
  },
  getSelectedNoteSubject(table_index) {
    const select = U.id(`heirNotesSubject_${table_index}`);
    const selectedValue = select && select.value;
    if (!selectedValue) return null;
    return (this.noteSubjectOptions || []).find((opt) => opt.option_value === selectedValue) || null;
  },
  async buildSoleHeirs(heirs) {
    const soleHeirDiv = U.id('soleHeirDiv');
    // -------------------------------
    // Party 1
    const p1Div = U.id('party1Div');
    p1Div.innerHTML = '';
    const p1 = U.divAtt('h6', 'class', '');
    p1.innerHTML = `Party 1 - ${this.party1_name} sole heir`;
    const label = `Party 2 (${this.party2_name}) sole heir if party 1 first dying`;
    let p1sole = true;

    if (!heirs.party1.heir_uuid) {
      p1sole = false;
    }
    //console.log(p1sole);
    const p1CheckBox = await comp.inputCheckbox('party1SoleHeirCheck', p1sole, label);
    p1Div.appendChild(p1);
    p1Div.appendChild(p1CheckBox);
    U.id('party1SoleHeirCheck').setAttribute('onchange', `thsSubTab.checkSoleHeirs('party1')`);

    // Other sole heir btn ---
    const addHeirBtn = U.divAtt('button', 'class', 'btn-icon btn-transparent mt-2');
    addHeirBtn.setAttribute('onclick', `thsSubTab.addSoleHeirs('party1')`);
    addHeirBtn.id = `btnparty1SoleHeir`;
    p1Div.appendChild(addHeirBtn);

    // Add name tag and button if party 2 not sole heir
    if (!p1sole && heirs.party1.heir_uuid) {
      this.buildNameTag('party1');
    }
    await this.buildParty1List(heirs.party1_list, p1sole);
    this.checkParty1Ratio('noUpdt');
    // -------------------------------
    // Party 2
    const p2Div = U.id('party2Div');
    p2Div.innerHTML = '';
    const p2 = U.divAtt('h6', 'class', '');
    p2.innerHTML = `Party 2 - ${this.party2_name} sole heir`;
    const label2 = `Party 1 (${this.party1_name}) sole heir if party 2 first dying`;
    let p2sole = true;

    if (!heirs.party2.heir_uuid) {
      p2sole = false;
    }
    const p2CheckBox = await comp.inputCheckbox('party2SoleHeirCheck', p2sole, label2);
    p2Div.appendChild(p2);
    p2Div.appendChild(p2CheckBox);
    U.id('party2SoleHeirCheck').setAttribute('onchange', `thsSubTab.checkSoleHeirs('party2')`);

    // Other sole heir btn ---
    const addHeirBtn2 = U.divAtt('button', 'class', 'btn-icon btn-transparent mt-2');
    addHeirBtn2.setAttribute('onclick', `thsSubTab.addSoleHeirs('party2')`);
    addHeirBtn.id = `btnparty2SoleHeir`;
    p2Div.appendChild(addHeirBtn2);

    // Add name tag annd button if party 2 not sole heir
    if (!p2sole && heirs.party2.heir_uuid) {
      this.buildNameTag('party2');
    }
    await this.buildParty2List(heirs.party2_list, p2sole);
    this.checkParty2Ratio('noUpdt');

    // -------------------------------
  },
  async buildParty1List(list, active) {
    //console.log(list);
    const table = U.id(`party1_heir_list`);
    table.innerHTML = '';
    // HEADER
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    const nameH = headRow.insertCell(0);
    nameH.innerHTML = 'Name';
    const relH = headRow.insertCell(1);
    relH.innerHTML = 'Relationship';
    const ratioH = headRow.insertCell(2);
    ratioH.innerHTML = 'Ratio';
    const removeH = headRow.insertCell(3);
    removeH.innerHTML = 'Remove';
    thead.appendChild(headRow);
    table.appendChild(thead);
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);
    if (list.children && list.children.length) {
      const childHrow = tbody.insertRow();
      const childrow = childHrow.insertCell(0);
      childrow.classList.add('subTHead');
      childrow.innerHTML = 'Children';
      childrow.colSpan = 4;

      list.children.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = (await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P1HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty1Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        childRow.insertCell(3);
      });
    }
    if (list.heirs && list.heirs.length) {
      const otherHrow = tbody.insertRow();
      const otherRow = otherHrow.insertCell(0);
      otherRow.classList.add('subTHead');
      otherRow.innerHTML = 'Heirs';
      otherRow.colSpan = 4;

      list.heirs.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = row.rel_party1; //(await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P1HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty1Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        const removeIcon = childRow.insertCell(3);
        const onclick = `thsSubTab.removeHeir('${row.application_heirs_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }
    if (list.company && list.company.length) {
      list.company.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = 'Organisation';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P1HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty1Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        const removeIcon = childRow.insertCell(3);
        const onclick = `thsSubTab.removeHeir('${row.heir_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }
    if ((!list.heirs || !list.heirs.length) && (!list.company || !list.company.length)) {
      //No  Heirs ---
      const heirRow = tbody.insertRow();
      const noHeir = heirRow.insertCell(0);
      noHeir.innerHTML = 'No heirs added.';
      noHeir.colSpan = 4;
    }
    if (active) {
      U.hide('party1Heirs');
    } else {
      U.unhide('party1Heirs');
    }
    const totalRow = tbody.insertRow();
    totalRow.classList.add('P1heirTotal');
    const totalH = totalRow.insertCell(0);
    totalH.innerHTML = 'Total';
    totalRow.insertCell(1);
    const total = totalRow.insertCell(2);
    total.id = 'P1totalRatio';
    totalRow.insertCell(3);
    //this.checkParty2Ratio('noUpdt');
  },
  async buildParty2List(list, active) {
    const table = U.id(`party2_heir_list`);
    table.innerHTML = '';
    // HEADER
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    const nameH = headRow.insertCell(0);
    nameH.innerHTML = 'Name';
    const relH = headRow.insertCell(1);
    relH.innerHTML = 'Relationship';
    const ratioH = headRow.insertCell(2);
    ratioH.innerHTML = 'Ratio';
    const removeH = headRow.insertCell(3);
    removeH.innerHTML = 'Remove';
    thead.appendChild(headRow);
    table.appendChild(thead);
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);
    if (list.children && list.children.length) {
      const childHrow = tbody.insertRow();
      const childrow = childHrow.insertCell(0);
      childrow.classList.add('subTHead');
      childrow.innerHTML = 'Children';
      childrow.colSpan = 4;

      list.children.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = (await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P2HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty1Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        childRow.insertCell(3);
      });
    }
    if (list.heirs && list.heirs.length) {
      const otherHrow = tbody.insertRow();
      const otherRow = otherHrow.insertCell(0);
      otherRow.classList.add('subTHead');
      otherRow.innerHTML = 'Heirs';
      otherRow.colSpan = 4;

      list.heirs.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = row.rel_party2; //(await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P2HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty2Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        const removeIcon = childRow.insertCell(3);
        const onclick = `thsSubTab.removeHeir('${row.application_heirs_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }
    if (list.company && list.company.length) {
      list.company.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = 'Organisation';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'P2HeirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkParty2Ratio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        const removeIcon = childRow.insertCell(3);
        const onclick = `thsSubTab.removeHeir('${row.heir_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }
    if ((!list.heirs || !list.heirs.length) && (!list.company || !list.company.length)) {
      //No  Heirs ---
      const heirRow = tbody.insertRow();
      const noHeir = heirRow.insertCell(0);
      noHeir.innerHTML = 'No heirs added.';
      noHeir.colSpan = 4;
    }
    if (active) {
      U.hide('party2Heirs');
    } else {
      U.unhide('party2Heirs');
    }
    const totalRow = tbody.insertRow();
    totalRow.classList.add('P2heirTotal');
    const totalH = totalRow.insertCell(0);
    totalH.innerHTML = 'Total';
    totalRow.insertCell(1);
    const total = totalRow.insertCell(2);
    total.id = 'P2totalRatio';
    totalRow.insertCell(3);
    //this.checkParty2Ratio('noUpdt');
  },
  checkParty1Ratio(noUpdt) {
    //@mike
    let sum = 0;
    const ratios = document.querySelectorAll('.P1HeirRatio');

    ratios.forEach((input) => {
      let value = parseFloat(input.value);
      if (isNaN(value) || value < 0) {
        input.value = '';
      }
      sum += Number(input.value) || 0;
    });
    if (sum > 100) {
      sum = 100;
    } else if (sum > 99.8 && sum < 100) {
      sum = 100;
    }
    U.id('P1totalRatio').innerHTML = `${sum}/100`;
    if (sum === 100) {
      U.id('P1totalRatio').classList.remove('error');
      if (!noUpdt) {
        this.updateP1HeirRatios();
      }
    } else {
      U.id('P1totalRatio').classList.add('error');
    }
  },
  async updateP1HeirRatios() {
    const ratios = document.querySelectorAll('.P1HeirRatio');
    const vars = {party1_heir: true, party2_heir: false};
    vars.application_uuid = this.application_uuid;
    vars.heirs = [];

    ratios.forEach((radio) => {
      let dataObj = {};
      dataObj.heir_uuid = radio.id;
      dataObj.share_ratio = radio.value;
      vars.heirs.push(dataObj);
    });
    O.PREP([await O.mPOST('application/ups-sole-heir-list', vars)])
      .then(async (res) => {
        const newHeirData = res['application/ups-sole-heir-list'].data;
        const msg = res['application/ups-sole-heir-list'].status;
        comp.toast(msg);
      })
      .catch(() => {});
  },
  heirCivillianFormObj({ includeOrganisation = true } = {}) {
    const inforObj = {
      formTitle: 'Add heir',
      ensureRelParty1: true,
      application_uuid: this.application_uuid,
      relationshipOptions: this.relationships,
      relationship: [this.party1_name],
    };
    if (includeOrganisation) {
      inforObj.organisation = 1;
    }
    this.party2_name && inforObj.relationship.push(this.party2_name);
    return inforObj;
  },
  async addP1Heir() {
    const data = await U.addCivillian(this.heirCivillianFormObj());
    if (data && data !== 'Canceled') {
      this.submitP1Heir(data);
    }
  },
  async submitP1Heir(data) {
    const vars = {party1_heir: true, party2_heir: false};
    vars.application_uuid = this.application_uuid;

    if (data.user_uuid) {
      vars.heir_uuid = data.user_uuid;
    } else {
      vars.other = {
        name: data.orgName,
        contact: data.orgContact,
        notes: data.orgNotes,
      };
    }

    O.PREP([await O.mPOST('application/ins-sole-heir-list', vars)]).then(async (res) => {
      const msg = res['application/ins-sole-heir-list'].status;
      comp.toast(msg);

      await this.refreshHeirDetails();
    });
  },
  checkParty2Ratio(noUpdt) {
    //@mike
    let sum = 0;
    const ratios = document.querySelectorAll('.P2HeirRatio');

    ratios.forEach((input) => {
      let value = parseFloat(input.value);
      if (isNaN(value) || value < 0) {
        input.value = '';
      }
      sum += Number(input.value) || 0;
    });
    if (sum > 100) {
      sum = 100;
    } else if (sum > 99.8 && sum < 100) {
      sum = 100;
    }
    U.id('P2totalRatio').innerHTML = `${sum}/100`;
    if (sum === 100) {
      U.id('P2totalRatio').classList.remove('error');
      if (!noUpdt) {
        this.updateP2HeirRatios();
      }
    } else {
      U.id('P2totalRatio').classList.add('error');
    }
  },
  async updateP2HeirRatios() {
    const ratios = document.querySelectorAll('.P2HeirRatio');
    const vars = {party1_heir: false, party2_heir: true};
    vars.application_uuid = this.application_uuid;
    vars.heirs = [];

    ratios.forEach((radio) => {
      let dataObj = {};
      dataObj.heir_uuid = radio.id;
      dataObj.share_ratio = radio.value;
      vars.heirs.push(dataObj);
    });
    O.PREP([await O.mPOST('application/ups-sole-heir-list', vars)])
      .then(async (res) => {
        const newHeirData = res['application/ups-sole-heir-list'].data;
        const msg = res['application/ups-sole-heir-list'].status;
        comp.toast(msg);
      })
      .catch(() => {});
  },
  async addP2Heir() {
    const data = await U.addCivillian(this.heirCivillianFormObj());
    if (data && data !== 'Canceled') {
      this.submitP2Heir(data);
    }
  },
  async submitP2Heir(data) {
    const vars = {party2_heir: true, party1_heir: false};
    vars.application_uuid = this.application_uuid;

    if (data.user_uuid) {
      vars.heir_uuid = data.user_uuid;
    } else {
      vars.other = {
        name: data.orgName,
        contact: data.orgContact,
        notes: data.orgNotes,
      };
    }

    O.PREP([await O.mPOST('application/ins-sole-heir-list', vars)]).then(async (res) => {
      const msg = res['application/ins-sole-heir-list'].status;
      comp.toast(msg);

      await this.refreshHeirDetails();
    });
  },
  async buildNameTag(forParty) {
    const nameTagSoleHeir = U.divAtt('div', 'class', 'nameTag mt-4');
    nameTagSoleHeir.id = `nameTag${forParty}SoleHeir`;
    nameTagSoleHeir.innerHTML = forParty === 'party1' ? this.party1_soleheir_name : this.party2_soleheir_name;
    U.id(`${forParty}Div`).appendChild(nameTagSoleHeir);
  },
  checkSoleHeirs(forParty) {
    const pCheckBoxID = forParty === 'party1' ? 'party1SoleHeirCheck' : 'party2SoleHeirCheck';
    const cb = U.id(`${pCheckBoxID}`);
    if (cb.checked === true) {
      // remove old heir
      if (U.id(`nameTag${forParty}SoleHeir`)) {
        U.id(`${forParty}Div`).removeChild(U.id(`nameTag${forParty}SoleHeir`));
      }
      if (forParty === 'party1') {
        U.hide('party1Heirs');
      } else {
        U.hide('party2Heirs');
      }
    } else {
      if (forParty === 'party1') {
        U.unhide('party1Heirs');
      } else {
        U.unhide('party2Heirs');
      }
    }
    this.updateSoleHeirs();
  },
  // addSoleHeirs(forParty) {
  //   // const pCheckBoxID = forParty === 'party1' ? 'party1SoleHeirCheck' : 'party2SoleHeirCheck';
  //   // const cb = U.id(`${pCheckBoxID}`);

  //   // if (cb.checked === true) {
  //   //   this.updateSoleHeirs();
  //   //   // remove old heir
  //   //   if (U.id(`nameTag${forParty}SoleHeir`)) {
  //   //     U.id(`${forParty}Div`).removeChild(U.id(`nameTag${forParty}SoleHeir`));
  //   //   };
  //   // } else {
  //   //   this.checkUser(forParty);
  //   // };

  //   this.checkUser(forParty);
  // },
  async addSoleHeirs(forParty) {
    const data = await U.addCivillian(this.heirCivillianFormObj({ includeOrganisation: false }));

    if (data && data !== 'Canceled') {
      // remove old heir
      if (U.id(`nameTag${forParty}SoleHeir`)) {
        U.id(`${forParty}Div`).removeChild(U.id(`nameTag${forParty}SoleHeir`));
      }
      //set new soleHeir
      (await forParty) === 'party1' ? (this.party1_soleheir_uuid = data.user_uuid) : (this.party2_soleheir_uuid = data.user_uuid);
      (await forParty) === 'party1' ? (this.party1_soleheir_name = data.full_name) : (this.party2_soleheir_name = data.full_name);
      // submit new heir
      this.buildNameTag(forParty);
      this.updateSoleHeirs();
    } else {
      //cancelled adding new sole heir
      // U.id(`${forParty}SoleHeirCheck`).checked = true;
    }
  },
  async updateSoleHeirs() {
    const vars = {};
    vars.application_uuid = this.application_uuid;

    vars.party1_heir_yn = U.id('party1SoleHeirCheck').checked;
    if (vars.party1_heir_yn) {
      vars.party1_heir_uuid = vars.party1_heir_yn ? this.party2_user_uuid : this.party1_soleheir_uuid;
    }

    vars.party2_heir_yn = U.id('party2SoleHeirCheck').checked;
    if (vars.party2_heir_yn) {
      // If there's a custom sole heir name tag, use that UUID, otherwise use party1_user_uuid
      if (U.id('nameTagParty2SoleHeir')) {
        vars.party2_heir_uuid = this.party2_soleheir_uuid;
      } else {
        vars.party2_heir_uuid = this.party1_user_uuid;
      }
    }

    O.PREP([await O.mPOST('application/ups_sole_heir', vars)]).then(async (res) => {
      const data = res['application/ups_sole_heir'].data;
      const msg = res['application/ups_sole_heir'].status;
      comp.toast(msg);
      await this.refreshHeirDetails();
    });
  },

  //Heir List -------
  async buildHeirListTable(data) {
    // Add this null check at the beginning
    if (!data) {
      return;
    }

    if (this.heirsData) {
      this.heirsData.heir_list = data;
    }

    const table = U.id(`heir_list`);
    table.innerHTML = '';

    // HEADER
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    const nameH = headRow.insertCell(0);
    nameH.innerHTML = 'Name';
    const relH = headRow.insertCell(1);
    relH.innerHTML = 'Relationship';
    const ratioH = headRow.insertCell(2);
    ratioH.innerHTML = 'Ratio';
    const editH = headRow.insertCell(3);
    editH.innerHTML = 'Edit';
    const removeH = headRow.insertCell(4);
    removeH.innerHTML = 'Remove';

    thead.appendChild(headRow);
    table.appendChild(thead);

    // BODY
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);

    if (data.children && Array.isArray(data.children) && data.children.length > 0) {
      const childHrow = tbody.insertRow();
      const childrow = childHrow.insertCell(0);
      childrow.classList.add('subTHead');
      childrow.innerHTML = 'Children';
      childrow.colSpan = 5;

      data.children.forEach(async (row) => {
        //console.log(row)
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = 'Child'; //(await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'heirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkRatio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        // ratioInpt.setAttribute('type', 'number');
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);
        childRow.insertCell(3);
        childRow.insertCell(4);
      });
    }

    if (data.heirs && data.heirs.length) {
      const otherHrow = tbody.insertRow();
      const otherRow = otherHrow.insertCell(0);
      otherRow.classList.add('subTHead');
      otherRow.innerHTML = 'Heirs';
      otherRow.colSpan = 5;

      data.heirs.forEach(async (row) => {
        //console.log(row)
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = row.rel_party1 || row.rel_party2; //(await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'heirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkRatio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);

        const editIcon = childRow.insertCell(3);
        const edit_onclick = `thsSubTab.fetchEditHeir('${row.application_heirs_uuid}','${row.heir_uuid}','heir')`;
        const editSVG = svg.edit(edit_onclick);
        editIcon.appendChild(editSVG);

        const removeIcon = childRow.insertCell(4);
        const onclick = `thsSubTab.removeHeir('${row.application_heirs_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }

    if (data.company && data.company.length) {
      // const otherHrow = tbody.insertRow();
      // const otherRow = otherHrow.insertCell(0);
      // otherRow.classList.add('subTHead');
      // otherRow.innerHTML = 'Heirs - Organisations';
      // otherRow.colSpan = 4;

      data.company.forEach(async (row) => {
        //console.log(row)
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = 'Organisation';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'heirRatio');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkRatio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);

        const editIcon = childRow.insertCell(3);
        const edit_onclick = `thsSubTab.fetchEditHeir('${row.bequeath_uuid}','${row.heir_uuid}','company')`;
        const editSVG = svg.edit(edit_onclick);
        editIcon.appendChild(editSVG);

        const removeIcon = childRow.insertCell(4);
        const onclick = `thsSubTab.removeHeir('${row.heir_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }

    if ((!data.heirs || !data.heirs.length) && (!data.children || !data.children.length) && (!data.company || !data.company.length)) {
      //No  Heirs ---
      const heirRow = tbody.insertRow();
      const noHeir = heirRow.insertCell(0);
      noHeir.innerHTML = 'No heirs added.';
      noHeir.colSpan = 5;
    }

    const totalRow = tbody.insertRow();
    totalRow.classList.add('heirTotal');
    const totalH = totalRow.insertCell(0);
    totalH.innerHTML = 'Total';
    totalRow.insertCell(1);
    const total = totalRow.insertCell(2);
    total.id = 'totalRatio';
    totalRow.insertCell(3);
    totalRow.insertCell(4);

    this.checkRatio('noUpdt');
  },
  checkRatio(noUpdt) {
    let sum = 0;
    const ratios = document.querySelectorAll('.heirRatio');
    // ('.FamOblitHeirRatio');

    ratios.forEach((input) => {
      let value = parseFloat(input.value);
      if (isNaN(value) || value < 0) {
        input.value = '';
      }

      let numericValue = input.value.replace(/[^0-9.]/g, '');
      sum += Number(numericValue) || 0;
    });

    // if (sum > 100) {
    //   sum = 100;
    // } else
    if (sum > 99.8 && sum < 100) {
      sum = 100;
    }

    U.id('totalRatio').innerHTML = `${sum}/100`;
    if (sum === 100) {
      U.id('totalRatio').classList.remove('error');
      if (!noUpdt) {
        this.updateHeirRatios();
      }
    } else {
      U.id('totalRatio').classList.add('error');
    }
  },
  async addHeir() {
    const data = await U.addCivillian(this.heirCivillianFormObj());
    if (data && data !== 'Canceled') {
      this.submitHeir(data);
    }
  },
  async fetchEditHeir(uuid, heir_uuid, type) {
    let vars = {bequeath_uuid: null, application_obliteration_uuid: null, application_heirs_uuid: null};
    if (type == 'company') {
      vars.bequeath_uuid = uuid;
    } else if (type == 'oblit') {
      vars.application_obliteration_uuid = uuid;
    } else {
      vars.application_heirs_uuid = uuid;
    }
    //'${row.application_heirs_uuid}','${row.heir_uuid}','heir'
    //'${row.bequeath_uuid}','${row.heir_uuid}','company'
    //'${row.application_obliteration_uuid}','${row.heir_uuid}','oblit'
    //'${row.bequeath_uuid}','${row.heir_uuid}','company'

    vars.application_uuid = this.application_uuid;
    vars.heir_uuid = heir_uuid;
    O.PREP([await O.mPOST('application/get-heir', vars)])
      .then(async (res) => {
        const heir = res['application/get-heir'].data;
        this.EditForm(heir, type);
      })
      .catch(() => {});
  },
  async EditForm(data, section) {
    let formHtml;
    let val1;
    let val2 = null;
    if (section == 'heir') {
      val1 = data.application_heirs_uuid;
      val2 = data.heir_uuid;
      formHtml = await this.buildEditHeir(data);
    } else if (section == 'oblit') {
      val1 = data.application_obliteration_uuid;
      val2 = data.heir_uuid;
      formHtml = await this.buildEditHeir(data);
    } else {
      val1 = data.bequeath_uuid;
      formHtml = await this.buildEditOrg(data);
    }
    const form = formHtml.outerHTML;
    const sectionCopy = this[`${section}`];

    const div = `
    <div
      id="childBox"
      class="fixed inset-0 z-50 overflow-y-auto bg-opacity-50 bg-black ">

      <div class="card relative transform overflow-hidden">
      <h4>Edit Heir</h4>

      <div id="newChild">
      ${form}
      </div>

      <div
      class="flex justify-center items-center" >
      <button class="btn-outline mr-4" onclick="U.closeModal('childBox')">Cancel</button>
      <button id="addChild-btn" onclick="thsSubTab.submitEditHeir('${val1}','${val2}','${section}')">Update</button>

    </div>`;

    const passBox = U.createHTMLElementFromString(div);
    document.body.prepend(passBox);
  },
  async buildEditHeir(child) {
    const grid2 = U.divAtt('div', 'class', 'res-grid-cols-2');
    const title = U.divAtt('h6', 'class', 'text-primary');
    title.innerHTML = `Heir Information`;
    let e_f_name = await comp.inputText(`f_name`, child.f_name, 'Full names ', 1);
    let e_s_name = await comp.inputText(`s_name`, child.s_name, 'Surname ', 1);
    let e_rel = await comp.select(`relationship`, this.relationships, 'relationship_uuid', 'short_text', 'Relationship', 1);
    const relationship_uuid = child.rel1_uuid || child.rel2_uuid;
    this.rel_party = child.rel1_uuid ? 'party1' : 'party2';
    const option = e_rel.querySelector(`option[value="${relationship_uuid}"]`);
    if (option) {
      // Set the selected attribute to make it the selected option
      option.setAttribute('selected', 'selected');
    }
    //let e_dob = await comp.inputDate(`newChild_dob`, child.dob, 'Date of birth ', 1);
    //let id_nr = await comp.inputNumber(`newChild_id`, child.id_nr, 'ID Number', 1);
    let p1_id_pass = await comp.inputIDPassport('idPass', child.id_nr ? 1 : 0, child.id_nr ? child.id_nr : child.passport_nr, 1);
    grid2.appendChild(e_f_name);
    grid2.appendChild(e_s_name);
    grid2.appendChild(e_rel);
    //grid2.appendChild(e_dob);
    grid2.appendChild(p1_id_pass);
    return grid2;
  },
  async buildEditOrg(child) {
    const grid2 = U.divAtt('div', 'class', 'res-grid-cols-2');
    const title = U.divAtt('h6', 'class', 'text-primary');
    title.innerHTML = `Company Information`;
    let name = await comp.inputText(`orgName`, child.f_name, 'Name ', 1);
    let contact = await comp.inputText(`orgContact`, child.contact, 'Contact ', 1);
    const notes = await comp.textarea('orgNotes', child.notes, 'Notes', 1);

    grid2.appendChild(name);
    grid2.appendChild(contact);
    grid2.appendChild(notes);
    return grid2;
  },
  async submitEditHeir(val1, val2, section) {
    // U.loaderBtn(1, 'addChild-btn');
    // let isValid = await U.validateForm('newChild');
    // if (!isValid) {
    //   U.loaderBtn(0, 'addChild-btn');
    //   return;
    // }
    const vars = {};
    vars.application_uuid = this.application_uuid;
    if (section == 'heir') {
      vars.application_heirs_uuid = val1;
      vars.heir_uuid = val2;
      vars.f_name = U.id('f_name').value;
      vars.s_name = U.id('s_name').value;
      if (this.rel_party == 'party1') {
        vars.rel_party1 = U.id('relationship').value;
        vars.rel_party2 = null;
      } else {
        vars.rel_party2 = U.id('relationship').value;
        vars.rel_party1 = null;
      }
      U.id('idPass').checked ? (vars.id_nr = U.id('idPass').value) : (vars.passport_nr = U.id('idPass').value);
    } else if (section == 'oblit') {
      vars.application_obliteration_uuid = val1;
      vars.heir_uuid = val2;
      vars.f_name = U.id('f_name').value;
      vars.s_name = U.id('s_name').value;
      if (this.rel_party == 'party1') {
        vars.rel_party1 = U.id('relationship').value;
        vars.rel_party2 = null;
      } else {
        vars.rel_party1 = null;
        vars.rel_party2 = U.id('relationship').value;
      }
      U.id('idPass').checked ? (vars.id_nr = U.id('idPass').value) : (vars.passport_nr = U.id('idPass').value);
    } else {
      vars.bequeath_uuid = val1;
      vars.orgName = U.id('orgName').value;
      vars.orgContact = U.id('orgContact').value;
      vars.orgNotes = U.id('orgNotes').value;
    }

    O.PREP([await O.mPOST('application/ups-heir', vars)])
      .then(async (res) => {
        const msg = res['application/ups-heir'].status;
        comp.toast(msg);
        U.closeModal('childBox');
        this.buildHeirListTable(res['application/ups-heir'].data.heirs);
        this.buildFamOblitHeirListTable(res['application/ups-heir'].data.obliterations);
        // const newChildData = res['application/ups-heir'].data[`${section}`];
        // this.buildChildTable(section, newChildData, section === 'other' ? 1 : 0);
      })
      .catch(() => {
        U.loaderBtn(0, 'addChild-btn');
      });
  },
  async submitHeir(data) {
    const vars = {};
    vars.application_uuid = this.application_uuid;

    if (data.user_uuid) {
      vars.heir_uuid = data.user_uuid;
      const relParty1 = U.resolveRelationshipUuid(data.rel_party1, this.relationships);
      const relParty2 = U.resolveRelationshipUuid(data.rel_party2, this.relationships);
      if (relParty1) {
        vars.rel_party1 = relParty1;
      }
      if (relParty2) {
        vars.rel_party2 = relParty2;
      }
      if (!relParty1 && !relParty2) {
        const relUuid = U.resolveRelationshipUuid(data.relationship_uuid, this.relationships);
        if (relUuid) {
          vars.rel_party1 = relUuid;
        }
      }
    } else {
      vars.other = {
        name: data.orgName,
        contact: data.orgContact,
        notes: data.orgNotes,
      };
    }

    O.PREP([await O.mPOST('application/ins-heir-list', vars)])
      .then(async (res) => {
        const msg = res['application/ins-heir-list'].status;
        comp.toast(msg);

        const newHeirData = res['application/ins-heir-list'].data;
        this.buildHeirListTable(newHeirData);
      })
      .catch(() => {
        U.loaderBtn(0, 'newHeir-btn');
      });
  },
  async removeHeir(heirID) {
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.application_heirs_uuid = heirID;

    O.PREP([await O.mPOST('application/rmv-heir-list', vars)])
      .then(async (res) => {
        const msg = res['application/rmv-heir-list'].status;
        comp.toast(msg);
        await this.refreshHeirDetails();
      })
      .catch(() => {});
  },
  async updateHeirRatios() {
    const ratios = document.querySelectorAll('.heirRatio');
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.heirs = [];

    ratios.forEach((radio) => {
      let dataObj = {};
      dataObj.heir_uuid = radio.id;
      let numericValue = radio.value.replace(/[^0-9.]/g, '');
      dataObj.share_ratio = numericValue;
      vars.heirs.push(dataObj);
    });
    //console.log(vars);
    O.PREP([await O.mPOST('application/ups-heir-list', vars)])
      .then(async (res) => {
        const newHeirData = res['application/ups-heir-list'].data;
        const msg = res['application/ups-heir-list'].status;
        comp.toast(msg);
        this.buildHeirListTable(newHeirData);
      })
      .catch(() => {});
  },
  //Heir List -------
  async buildFamOblitHeirListTable(data) {
    if (this.heirsData && data) {
      this.heirsData.obliteration_list = data;
    }

    const table = U.id(`famOblit_list`);
    table.innerHTML = '';

    // HEADER
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    const nameH = headRow.insertCell(0);
    nameH.innerHTML = 'Name';
    const relH = headRow.insertCell(1);
    relH.innerHTML = 'Relationship';
    const ratioH = headRow.insertCell(2);
    ratioH.innerHTML = 'Ratio';
    const editH = headRow.insertCell(3);
    editH.innerHTML = 'Edit';
    const removeH = headRow.insertCell(4);
    removeH.innerHTML = 'Remove';

    thead.appendChild(headRow);
    table.appendChild(thead);

    // BODY
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);

    if (data.heirs && data.heirs.length) {
      data.heirs.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = row.rel_party1 || row.rel_party2; //(await U.getTextByUuid(communal.relationships, 'relationship_uuid', row.relationship, 'short_text')) || '';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'FamOblitHeirRatio');
        ratioInpt.setAttribute('size', '10');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkFamOblitRatio()');
        // ratioInpt.setAttribute('type', 'number');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);

        const editIcon = childRow.insertCell(3);
        const edit_onclick = `thsSubTab.fetchEditHeir('${row.application_obliteration_uuid}','${row.heir_uuid}','oblit')`;
        const editSVG = svg.edit(edit_onclick);
        editIcon.appendChild(editSVG);

        const removeIcon = childRow.insertCell(4);
        const onclick = `thsSubTab.removeFamOblitHeir('${row.heir_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }

    if (data.company && data.company.length) {
      data.company.forEach(async (row) => {
        const childRow = tbody.insertRow();
        const name = childRow.insertCell(0);
        name.innerHTML = row.name;
        const rel = childRow.insertCell(1);
        rel.innerHTML = 'Organisation';
        const ratio = childRow.insertCell(2);
        const ratioInpt = U.divAtt('input', 'class', 'FamOblitHeirRatio');
        ratioInpt.setAttribute('size', '10');
        ratioInpt.setAttribute('onkeyup', 'thsSubTab.checkFamOblitRatio()');
        ratioInpt.setAttribute('value', !row.share_ratio ? 0 : `${row.share_ratio}`);
        ratioInpt.id = row.heir_uuid;
        ratio.appendChild(ratioInpt);

        const editIcon = childRow.insertCell(3);
        const edit_onclick = `thsSubTab.fetchEditHeir('${row.bequeath_uuid}','${row.heir_uuid}','company')`;
        const editSVG = svg.edit(edit_onclick);
        editIcon.appendChild(editSVG);

        const removeIcon = childRow.insertCell(4);
        const onclick = `thsSubTab.removeFamOblitHeir('${row.heir_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      });
    }

    if ((!data.heirs || !data.heirs.length) && (!data.company || !data.company.length)) {
      //No  Heirs ---
      const heirRow = tbody.insertRow();
      const noHeir = heirRow.insertCell(0);
      noHeir.innerHTML = 'No heirs added.';
      noHeir.colSpan = 5;
    }

    const totalRow = tbody.insertRow();
    totalRow.classList.add('heirTotal');
    const totalH = totalRow.insertCell(0);
    totalH.innerHTML = 'Total';
    totalRow.insertCell(1);
    const total = totalRow.insertCell(2);
    total.id = 'FamOblittotalRatio';
    totalRow.insertCell(3);
    totalRow.insertCell(4);

    this.checkFamOblitRatio('noUpdt');
  },
  checkFamOblitRatio(noUpdt) {
    //@mike
    let sum = 0;
    const ratios = document.querySelectorAll('.FamOblitHeirRatio');

    ratios.forEach((input) => {
      let value = parseFloat(input.value);
      if (isNaN(value) || value < 0) {
        input.value = '';
      }
      let numericValue = input.value.replace(/[^0-9.]/g, '');
      sum += Number(numericValue) || 0;
    });
    // if (sum > 100) {
    //   sum = 100;
    // } else
    if (sum > 99.8 && sum < 100) {
      sum = 100;
    }
    U.id('FamOblittotalRatio').innerHTML = `${sum}/100`;
    if (sum === 100) {
      U.id('FamOblittotalRatio').classList.remove('error');
      if (!noUpdt) {
        this.updateFamOblitHeirRatios();
      }
    } else {
      U.id('FamOblittotalRatio').classList.add('error');
    }
  },
  async addFamOblitHeir() {
    const data = await U.addCivillian(this.heirCivillianFormObj());
    if (data && data !== 'Canceled') {
      this.submitFamOblitHeir(data);
    }
  },
  async submitFamOblitHeir(data) {
    const vars = {};
    vars.application_uuid = this.application_uuid;
    if (data.user_uuid) {
      vars.heir_uuid = data.user_uuid;
      const relUuid = U.resolveRelationshipUuid(
        data.relationship_uuid || data.rel_party1,
        this.relationships
      );
      if (relUuid) {
        vars.rel_party1 = relUuid;
      }
    } else {
      vars.other = {
        name: data.orgName,
        contact: data.orgContact,
        notes: data.orgNotes,
      };
    }

    O.PREP([await O.mPOST('application/ins-obliteration-list', vars)]).then(async (res) => {
      const msg = res['application/ins-obliteration-list'].status;
      comp.toast(msg);

      const newHeirData = res['application/ins-obliteration-list'].data;
      this.buildFamOblitHeirListTable(newHeirData);
    });
  },
  async removeFamOblitHeir(heirID) {
    const method = 'application/rmv-obliteration-list';
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.application_obliteration_uuid = heirID;

    O.PREP([await O.mPOST(method, vars)]).then(async (res) => {
      const newHeirData = res[method].data;
      const msg = res[method].status;
      comp.toast(msg);
      this.buildFamOblitHeirListTable(newHeirData);
    });
  },
  async updateFamOblitHeirRatios() {
    const ratios = document.querySelectorAll('.FamOblitHeirRatio');
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.heirs = [];

    ratios.forEach((radio) => {
      let dataObj = {};
      dataObj.heir_uuid = radio.id;
      let numericValue = radio.value.replace(/[^0-9.]/g, '');
      dataObj.share_ratio = numericValue;
      vars.heirs.push(dataObj);
    });
    O.PREP([await O.mPOST('application/ups-obliteration-list', vars)])
      .then(async (res) => {
        const newHeirData = res['application/ups-obliteration-list'].data;
        const msg = res['application/ups-obliteration-list'].status;
        comp.toast(msg);
        this.buildFamOblitHeirListTable(newHeirData);
      })
      .catch(() => {});
  },
  async saveNotes(table_index, { idKey } = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const key = idKey || table_index;
        const subjectSelect = U.id(`heirNotesSubject_${key}`);
        const subject = subjectSelect ? this.getSelectedNoteSubject(key) : null;
        if (subjectSelect && !subject) {
          comp.toast('Please select a party or heir for the note');
          reject(new Error('note subject required'));
          return;
        }
        const vars = {};
        vars.application_uuid = this.application_uuid;
        vars.table_index = table_index;
        if (subject) {
          vars.party = subject.party;
          vars.party_uuid = subject.party_uuid;
        } else if (Number(table_index) % 10 === 3) {
          vars.party = 'obliteration';
        }
        vars.note = (U.id(`heirNotes_${key}`) && U.id(`heirNotes_${key}`).value) || '';

        O.PREP([await O.mPOST('application/ups-heir-notes', vars)]).then(async () => {
          this[`heir_notes_${table_index}`] = vars.note;
          this.heir_notes_meta = this.heir_notes_meta || {};
          this.heir_notes_meta[table_index] = {
            party: vars.party,
            party_uuid: vars.party_uuid,
          };
          const existing = (this.heirNotesList || []).find(
            (note) => Number(note.table_index) === Number(table_index)
          );
          if (existing) {
            existing.note = vars.note;
            existing.party = vars.party;
            existing.party_uuid = vars.party_uuid;
          } else {
            this.heirNotesList = this.heirNotesList || [];
            this.heirNotesList.push({
              table_index,
              note: vars.note,
              party: vars.party,
              party_uuid: vars.party_uuid,
            });
          }
          const btn = U.id(`updateNotesBtn_${key}`);
          if (btn) btn.disabled = true;
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  async updateExistingNote(table_index) {
    try {
      await this.saveNotes(table_index);
      comp.toast('Notes updated');
    } catch (error) {
      if (error?.message !== 'note subject required') {
        comp.toast('Failed to update notes');
      }
    }
  },
  async addNewNote(sectionIndex, { refresh = true } = {}) {
    try {
      const idKey = `new_${sectionIndex}`;
      const textarea = U.id(`heirNotes_${idKey}`);
      if (!textarea || !String(textarea.value || '').trim()) {
        comp.toast('Please enter a note');
        return;
      }
      const table_index = this.nextTableIndex(sectionIndex);
      await this.saveNotes(table_index, { idKey });
      comp.toast('Notes added');
      if (refresh) await this.refreshHeirDetails();
    } catch (error) {
      if (error?.message !== 'note subject required') {
        comp.toast('Failed to add notes');
      }
    }
  },
  async removeNotes(table_index) {
    try {
      const vars = {
        application_uuid: this.application_uuid,
        table_index,
      };
      const res = await O.PREP([await O.mPOST('application/rmv-heir-notes', vars)]);
      const msg = res['application/rmv-heir-notes']?.status || 'Heir notes removed';
      this[`heir_notes_${table_index}`] = '';
      if (this.heir_notes_meta) {
        this.heir_notes_meta[table_index] = { party: '', party_uuid: '' };
      }
      this.heirNotesList = (this.heirNotesList || []).filter(
        (note) => Number(note.table_index) !== Number(table_index)
      );
      comp.toast(msg);
      await this.refreshHeirDetails();
    } catch (error) {
      comp.toast('Failed to remove notes');
    }
  },
  async saveAllVisibleNotes() {
    for (const note of this.heirNotesList || []) {
      if (U.id(`heirNotes_${note.table_index}`)) {
        await this.saveNotes(note.table_index);
      }
    }
    for (const section of [1, 2, 3, 4]) {
      const textarea = U.id(`heirNotes_new_${section}`);
      if (textarea && String(textarea.value || '').trim()) {
        const table_index = this.nextTableIndex(section);
        await this.saveNotes(table_index, { idKey: `new_${section}` });
      }
    }
  },

  //Save Page -------
  async savePage(nextPrev) {
    // Hide previous error message
    const errorDiv = U.id('heirsValidationError');
    if (errorDiv) {
      errorDiv.style.display = 'none';
      errorDiv.textContent = '';
    }

    // Validate sections before proceeding (only if going to next page)
    if (nextPrev === 'next_page') {
      // Party 1 must have sole heir indicated (checkbox checked or heirs in list)
      if (this.testament === 'Joint') {
        const soleHeirDiv = U.id('soleHeirDiv');
        if (soleHeirDiv && soleHeirDiv.style.display !== 'none') {
          const p1Checkbox = U.id('party1SoleHeirCheck');
          const p1HasSoleHeir = p1Checkbox && p1Checkbox.checked;
          const p1HasHeirsInList = this.hasParty1HeirsInList();
          if (!p1HasSoleHeir && !p1HasHeirsInList) {
            if (errorDiv) {
              errorDiv.textContent = 'Party1 needs to have a sole heir indicated.';
              errorDiv.style.display = 'block';
            }
            return;
          }

          const p2Checkbox = U.id('party2SoleHeirCheck');
          const p2HasSoleHeir = p2Checkbox && p2Checkbox.checked;
          const p2HasHeirsInList = this.hasParty2HeirsInList();
          if (!p2HasSoleHeir && !p2HasHeirsInList) {
            if (errorDiv) {
              errorDiv.textContent = 'Party2 needs to have a sole heir indicated.';
              errorDiv.style.display = 'block';
            }
            return;
          }
        }
      }

      const heirIssues = this.getHeirsValidationIssues();
      if (heirIssues.length > 0) {
        if (errorDiv) {
          const preamble =
            this.testament === 'Joint'
              ? 'Complete sections A (sole heir), B (will of the survivor / simultaneous death), and C (family obliteration). '
              : 'Complete sections A (heir ratio) and B (family obliteration). ';
          errorDiv.textContent =
            preamble +
            'Continue is blocked until every requirement is met: ' +
            heirIssues.join(' — ');
          errorDiv.style.display = 'block';
        }
        return;
      }
    }

    if (nextPrev !== 'next_page') {
      try {
        await this.saveAllVisibleNotes();
      } catch (error) {
        if (error?.message === 'note subject required') return;
        throw error;
      }
    }

    if (nextPrev === 'next_page') {
      const heirVars = {
        application_uuid: this.application_uuid,
        commenced: true,
        complete: true,
      };
      await O.PREP([await O.mPOST('application/upd-heirs-complete', heirVars)]);
    }

    const method = 'application/val-app-page';
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.page_name = 'ADs_Heirs';
    O.PREP([await O.mPOST(method, vars)])
      .then(async (res) => {
        comp.toast(res[method].status);
        thsPage.pageProgress(res[method].data, nextPrev);
      })
      .catch(() => {});
  },

  // Check if Party 1 has heirs in the sole heir list (party1_list.heirs)
  hasParty1HeirsInList() {
    const p1Table = U.id('party1_heir_list');
    if (!p1Table) return false;
    const p1Tbody = p1Table.querySelector('tbody');
    if (!p1Tbody) return false;
    const p1Rows = p1Tbody.querySelectorAll('tr');
    for (let row of p1Rows) {
      const cells = row.querySelectorAll('td');
      if (cells.length > 0) {
        const cellText = cells[0].textContent.trim();
        if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('P1heirTotal')) {
          const nameCell = cells[0];
          if (nameCell && nameCell.textContent.trim() && nameCell.textContent.trim() !== 'Children' && nameCell.textContent.trim() !== 'Heirs') {
            return true;
          }
        }
      }
    }
    return false;
  },

  // Check if Party 2 has heirs in the sole heir list (party2_list.heirs)
  hasParty2HeirsInList() {
    const p2Table = U.id('party2_heir_list');
    if (!p2Table) return false;
    const p2Tbody = p2Table.querySelector('tbody');
    if (!p2Tbody) return false;
    const p2Rows = p2Tbody.querySelectorAll('tr');
    for (let row of p2Rows) {
      const cells = row.querySelectorAll('td');
      if (cells.length > 0) {
        const cellText = cells[0].textContent.trim();
        if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('P2heirTotal')) {
          const nameCell = cells[0];
          if (nameCell && nameCell.textContent.trim() && nameCell.textContent.trim() !== 'Children' && nameCell.textContent.trim() !== 'Heirs') {
            return true;
          }
        }
      }
    }
    return false;
  },

  // Joint: A (sole heir per party) + B (main heir list 100%) + C (obliteration 100%). Single: UI A = heir list, UI B = obliteration
  getHeirsValidationIssues() {
    const data = this.heirsData;
    if (!data) {
      const issues = ['Heir data is not loaded yet; wait for the page to finish loading, then try again.'];
      this.logHeirsValidationDiagnostics(issues);
      return issues;
    }

    const issues = [];

    if (this.testament === 'Joint') {
      const p1TotalRatio = U.id('P1totalRatio')?.innerHTML?.trim();
      const p2TotalRatio = U.id('P2totalRatio')?.innerHTML?.trim();
      const mainHeirTotalRatio = U.id('totalRatio')?.innerHTML?.trim();
      const famOblitTotalRatio = U.id('FamOblittotalRatio')?.innerHTML?.trim();

      const p1HasHeirs = (data.party1_list?.heirs?.length > 0) || (data.party1_list?.children?.length > 0) || (data.party1_list?.company?.length > 0);
      const p2HasHeirs = (data.party2_list?.heirs?.length > 0) || (data.party2_list?.children?.length > 0) || (data.party2_list?.company?.length > 0);
      const p1SoleHeirOnly = (data.party1?.heir_uuid != null) && !p1HasHeirs;
      const p2SoleHeirOnly = (data.party2?.heir_uuid != null) && !p2HasHeirs;

      const p1HasSoleOrHeirs =
        (data.party1_list?.heirs?.length > 0) || (data.party1?.heir_uuid != null);
      const p2HasSoleOrHeirs =
        (data.party2_list?.heirs?.length > 0) || (data.party2?.heir_uuid != null);

      if (!p1HasSoleOrHeirs) {
        issues.push(
          'Section A — Party 1: either the sole heir must be set or at least one heir must appear in Party 1’s list.'
        );
      } else if (!p1SoleHeirOnly && p1TotalRatio !== '100/100') {
        issues.push(
          `Section A — Party 1: when there is more than the sole heir, heir shares must total exactly 100/100 (now ${p1TotalRatio || 'incomplete'}).`
        );
      }

      if (!p2HasSoleOrHeirs) {
        issues.push(
          'Section A — Party 2: either the sole heir must be set or at least one heir must appear in Party 2’s list.'
        );
      } else if (!p2SoleHeirOnly && p2TotalRatio !== '100/100') {
        issues.push(
          `Section A — Party 2: when there is more than the sole heir, heir shares must total exactly 100/100 (now ${p2TotalRatio || 'incomplete'}).`
        );
      }

      const bHasEntries =
        (data.heir_list?.heirs?.length > 0) ||
        (data.heir_list?.children?.length > 0) ||
        (data.heir_list?.company?.length > 0);
      if (!bHasEntries) {
        issues.push(
          'Section B: add at least one heir, child, or company to the main residue list.'
        );
      } else if (mainHeirTotalRatio !== '100/100') {
        issues.push(
          `Section B: residue shares must total exactly 100/100 (now ${mainHeirTotalRatio || 'incomplete'}).`
        );
      }

      const ob = data.obliteration_list;
      const oblitHasEntries =
        (ob?.heirs?.length > 0) || (ob?.company?.length > 0);
      if (!oblitHasEntries) {
        issues.push(
          'Section C (family obliteration): add at least one heir or company to that list.'
        );
      } else if (famOblitTotalRatio !== '100/100') {
        issues.push(
          `Section C (family obliteration): shares must total exactly 100/100 (now ${famOblitTotalRatio || 'incomplete'}).`
        );
      }

      this.logHeirsValidationDiagnostics(issues);
      return issues;
    }

    // Single testament: on screen, headings are “A. Heir Ratio” and “B. Family Obliteration”
    const totalRatio = U.id('totalRatio')?.innerHTML?.trim();
    const famOblitTotalRatio = U.id('FamOblittotalRatio')?.innerHTML?.trim();
    const aHasEntries =
      (data.heir_list?.heirs?.length > 0) ||
      (data.heir_list?.children?.length > 0) ||
      (data.heir_list?.company?.length > 0);
    const ob = data.obliteration_list;
    const bHasOblitEntries = (ob?.heirs?.length > 0) || (ob?.company?.length > 0);

    if (!aHasEntries) {
      issues.push(
        'Section A (heir ratio): add at least one heir, child, or company—the table cannot be empty.'
      );
    } else if (totalRatio !== '100/100') {
      issues.push(
        `Section A (heir ratio): every included share must sum to exactly 100/100 in the total row (now ${totalRatio || 'incomplete'}).`
      );
    }

    if (!bHasOblitEntries) {
      issues.push(
        'Section B (family obliteration): add at least one heir or company—the obliteration table cannot be empty.'
      );
    } else if (famOblitTotalRatio !== '100/100') {
      issues.push(
        `Section B (family obliteration): obliteration shares must sum to exactly 100/100 (now ${famOblitTotalRatio || 'incomplete'}).`
      );
    }

    this.logHeirsValidationDiagnostics(issues);
    return issues;
  },

  logHeirsValidationDiagnostics(issues) {
    const data = this.heirsData;
    const testament = this.testament;
    const totalRatio = U.id('totalRatio')?.innerHTML?.trim();
    const famOblitTotalRatio = U.id('FamOblittotalRatio')?.innerHTML?.trim();
    const ob = data?.obliteration_list;
    const heirList = data?.heir_list;

    const domHeirRows = this.countVisibleTableRows('heir_list');
    const domOblitRows = this.countVisibleTableRows('famOblit_list');

    const checks = [];

    if (testament === 'Joint') {
      const p1TotalRatio = U.id('P1totalRatio')?.innerHTML?.trim();
      const p2TotalRatio = U.id('P2totalRatio')?.innerHTML?.trim();
      const p1HasSoleOrHeirs =
        (data?.party1_list?.heirs?.length > 0) || (data?.party1?.heir_uuid != null);
      const p2HasSoleOrHeirs =
        (data?.party2_list?.heirs?.length > 0) || (data?.party2?.heir_uuid != null);
      const bHasEntries =
        (heirList?.heirs?.length > 0) ||
        (heirList?.children?.length > 0) ||
        (heirList?.company?.length > 0);
      const oblitHasEntries = (ob?.heirs?.length > 0) || (ob?.company?.length > 0);

      checks.push({
        check: 'Section A — Party 1 sole heir or list',
        pass: p1HasSoleOrHeirs,
        detail: `party1_list.heirs=${data?.party1_list?.heirs?.length ?? 0}, party1.heir_uuid=${data?.party1?.heir_uuid ?? 'null'}`,
      });
      checks.push({
        check: 'Section A — Party 1 ratio 100/100',
        pass: p1HasSoleOrHeirs && (p1TotalRatio === '100/100' || ((data?.party1?.heir_uuid != null) && !(data?.party1_list?.heirs?.length > 0))),
        detail: `P1totalRatio=${p1TotalRatio || 'missing'}`,
      });
      checks.push({
        check: 'Section A — Party 2 sole heir or list',
        pass: p2HasSoleOrHeirs,
        detail: `party2_list.heirs=${data?.party2_list?.heirs?.length ?? 0}, party2.heir_uuid=${data?.party2?.heir_uuid ?? 'null'}`,
      });
      checks.push({
        check: 'Section A — Party 2 ratio 100/100',
        pass: p2HasSoleOrHeirs && (p2TotalRatio === '100/100' || ((data?.party2?.heir_uuid != null) && !(data?.party2_list?.heirs?.length > 0))),
        detail: `P2totalRatio=${p2TotalRatio || 'missing'}`,
      });
      checks.push({
        check: 'Section B — main residue list has entries (heirsData)',
        pass: bHasEntries,
        detail: `heir_list.heirs=${heirList?.heirs?.length ?? 0}, children=${heirList?.children?.length ?? 0}, company=${heirList?.company?.length ?? 0}, DOM rows=${domHeirRows}`,
      });
      checks.push({
        check: 'Section B — main residue ratio 100/100',
        pass: bHasEntries && totalRatio === '100/100',
        detail: `totalRatio=${totalRatio || 'missing'}`,
      });
      checks.push({
        check: 'Section C — obliteration list has entries (heirsData)',
        pass: oblitHasEntries,
        detail: `obliteration_list.heirs=${ob?.heirs?.length ?? 0}, company=${ob?.company?.length ?? 0}, DOM rows=${domOblitRows}`,
      });
      checks.push({
        check: 'Section C — obliteration ratio 100/100',
        pass: oblitHasEntries && famOblitTotalRatio === '100/100',
        detail: `FamOblittotalRatio=${famOblitTotalRatio || 'missing'}`,
      });
    } else {
      const aHasEntries =
        (heirList?.heirs?.length > 0) ||
        (heirList?.children?.length > 0) ||
        (heirList?.company?.length > 0);
      const bHasOblitEntries = (ob?.heirs?.length > 0) || (ob?.company?.length > 0);

      checks.push({
        check: 'Section A (heir ratio) — list has entries (heirsData)',
        pass: aHasEntries,
        detail: `heir_list.heirs=${heirList?.heirs?.length ?? 0}, children=${heirList?.children?.length ?? 0}, company=${heirList?.company?.length ?? 0}, DOM rows=${domHeirRows}`,
      });
      checks.push({
        check: 'Section A (heir ratio) — total 100/100',
        pass: aHasEntries && totalRatio === '100/100',
        detail: `totalRatio=${totalRatio || 'missing'}`,
      });
      checks.push({
        check: 'Section B (family obliteration) — list has entries (heirsData)',
        pass: bHasOblitEntries,
        detail: `obliteration_list.heirs=${ob?.heirs?.length ?? 0}, company=${ob?.company?.length ?? 0}, DOM rows=${domOblitRows}`,
      });
      checks.push({
        check: 'Section B (family obliteration) — total 100/100',
        pass: bHasOblitEntries && famOblitTotalRatio === '100/100',
        detail: `FamOblittotalRatio=${famOblitTotalRatio || 'missing'}`,
      });

      if (domOblitRows > 0 && !bHasOblitEntries) {
        checks.push({
          check: '⚠ Stale heirsData — obliteration visible in DOM but empty in heirsData',
          pass: false,
          detail: 'Validation uses heirsData from page load; add/remove/ratio updates may not have refreshed it.',
        });
      }
      if (domHeirRows > 0 && !aHasEntries) {
        checks.push({
          check: '⚠ Stale heirsData — heir ratio visible in DOM but empty in heirsData',
          pass: false,
          detail: 'Validation uses heirsData from page load; add/remove/ratio updates may not have refreshed it.',
        });
      }
    }

    const failing = checks.filter((c) => !c.pass);

    console.group('[Heirs validation] Continue button checks');
    console.log('Testament:', testament);
    console.log('Blocked:', issues.length > 0);
    if (issues.length > 0) {
      console.log('User-facing messages:', issues);
    }
    console.table(checks.map((c) => ({ check: c.check, pass: c.pass ? '✓' : '✗', detail: c.detail })));
    if (failing.length) {
      console.warn(
        'Failing checks:',
        failing.map((c) => c.check)
      );
    } else if (issues.length > 0) {
      console.warn('Checks passed in table but issues remain:', issues);
    } else {
      console.log('All checks passed — Continue is allowed.');
    }
    console.groupEnd();
  },

  countVisibleTableRows(tableId) {
    const table = U.id(tableId);
    if (!table) return 0;
    const tbody = table.querySelector('tbody');
    if (!tbody) return 0;
    let count = 0;
    tbody.querySelectorAll('tr').forEach((row) => {
      const cellText = row.querySelector('td')?.textContent?.trim() || '';
      if (
        cellText &&
        cellText !== 'No heirs added.' &&
        cellText !== 'Total' &&
        cellText !== 'Children' &&
        cellText !== 'Heirs' &&
        !row.classList.contains('heirTotal') &&
        !row.classList.contains('P1heirTotal') &&
        !row.classList.contains('P2heirTotal')
      ) {
        count += 1;
      }
    });
    return count;
  },

  validateHeirsSections() {
    return this.getHeirsValidationIssues().length === 0;
  },

  // Check if Section A (Sole Heir) has entries
  hasSectionAEntries() {
    // Section A is only visible for Joint testaments
    if (this.testament !== 'Joint') {
      return false;
    }

    const soleHeirDiv = U.id('soleHeirDiv');
    if (!soleHeirDiv || soleHeirDiv.style.display === 'none') {
      return false;
    }

    // Check if sole heir checkboxes are checked (this counts as completing Section A)
    const p1Checkbox = U.id('party1SoleHeirCheck');
    const p2Checkbox = U.id('party2SoleHeirCheck');
    if (p1Checkbox && p1Checkbox.checked) {
      return true;
    }
    if (p2Checkbox && p2Checkbox.checked) {
      return true;
    }

    // Check if there are name tags for sole heirs
    if (U.id('nameTagParty1SoleHeir') || U.id('nameTagParty2SoleHeir')) {
      return true;
    }

    // Check party1_heir_list table for entries
    const p1Table = U.id('party1_heir_list');
    if (p1Table) {
      const p1Tbody = p1Table.querySelector('tbody');
      if (p1Tbody) {
        const p1Rows = p1Tbody.querySelectorAll('tr');
        // Check if there are rows that are not "No heirs added" and not total row
        for (let row of p1Rows) {
          const cells = row.querySelectorAll('td');
          if (cells.length > 0) {
            const cellText = cells[0].textContent.trim();
            if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('P1heirTotal')) {
              // Check if this row has actual heir data (has input field with value > 0 or has name)
              const ratioInput = row.querySelector('.P1HeirRatio');
              const nameCell = cells[0];
              if (nameCell && nameCell.textContent.trim() && nameCell.textContent.trim() !== 'Children' && nameCell.textContent.trim() !== 'Heirs') {
                if (!ratioInput || parseFloat(ratioInput.value) > 0) {
                  return true;
                }
              }
            }
          }
        }
      }
    }

    // Check party2_heir_list table for entries
    const p2Table = U.id('party2_heir_list');
    if (p2Table) {
      const p2Tbody = p2Table.querySelector('tbody');
      if (p2Tbody) {
        const p2Rows = p2Tbody.querySelectorAll('tr');
        // Check if there are rows that are not "No heirs added" and not total row
        for (let row of p2Rows) {
          const cells = row.querySelectorAll('td');
          if (cells.length > 0) {
            const cellText = cells[0].textContent.trim();
            if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('P2heirTotal')) {
              // Check if this row has actual heir data
              const ratioInput = row.querySelector('.P2HeirRatio');
              const nameCell = cells[0];
              if (nameCell && nameCell.textContent.trim() && nameCell.textContent.trim() !== 'Children' && nameCell.textContent.trim() !== 'Heirs') {
                if (!ratioInput || parseFloat(ratioInput.value) > 0) {
                  return true;
                }
              }
            }
          }
        }
      }
    }

    return false;
  },

  // Check if Section B (Heir Ratio's) has entries
  hasSectionBEntries() {
    const heirTable = U.id('heir_list');
    if (!heirTable) {
      return false;
    }

    const tbody = heirTable.querySelector('tbody');
    if (!tbody) {
      return false;
    }

    const rows = tbody.querySelectorAll('tr');
    // Check if there are rows that are not "No heirs added" and not total row
    for (let row of rows) {
      const cells = row.querySelectorAll('td');
      if (cells.length > 0) {
        const cellText = cells[0].textContent.trim();
        if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('heirTotal')) {
          // Check if this row has actual heir data
          const ratioInput = row.querySelector('.heirRatio');
          const nameCell = cells[0];
          if (nameCell && nameCell.textContent.trim() && nameCell.textContent.trim() !== 'Children' && nameCell.textContent.trim() !== 'Heirs') {
            if (!ratioInput || parseFloat(ratioInput.value) > 0) {
              return true;
            }
          }
        }
      }
    }

    return false;
  },

  // Check if Section C (Family Obliteration) has entries
  hasSectionCEntries() {
    const famOblitTable = U.id('famOblit_list');
    if (!famOblitTable) {
      return false;
    }

    const tbody = famOblitTable.querySelector('tbody');
    if (!tbody) {
      return false;
    }

    const rows = tbody.querySelectorAll('tr');
    // Check if there are rows that are not "No heirs added" and not total row
    for (let row of rows) {
      const cells = row.querySelectorAll('td');
      if (cells.length > 0) {
        const cellText = cells[0].textContent.trim();
        if (cellText !== 'No heirs added.' && cellText !== 'Total' && !row.classList.contains('heirTotal')) {
          // If there's a name in the first cell, it counts as an entry
          const nameCell = cells[0];
          if (nameCell && nameCell.textContent.trim()) {
            return true;
          }
        }
      }
    }

    return false;
  },
};
